module.exports = __webpack_public_path__ + "public/img/home_main2_btnl@1x.ffa87519.png";